// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7742":"4819563d","9063":"3abae9f3"}[chunkId] + ".chunk.css";
};